import React, { memo } from 'react';

const ProductReviewsRatingItem = ({ score, reviewCount, label }) => {
  return (
    <div className='review-rating__item'>
      <p className='review-rating__rank'>{label} Star</p>
      <div className='review-rating__value'>
        <span style={{ width: `${score}%` }}></span>
      </div>
      <p className='review-rating__count'>({reviewCount})</p>
    </div>
  );
};

export default memo(ProductReviewsRatingItem);
